
  import { defineComponent } from 'vue'
  import { rehabilitationTermDescription } from '@/constants/rehabilitation'

  export default defineComponent({
    name: 'RehabilitationTerm',

    props: {
      // 화면에 표시할 용어(라벨)
      term: { type: String, required: true },
      // 설명 조회 키 — 화면 표기(term)와 사전 항목명이 다를 때만 지정 (예: 목록 「정산확정금액」 → '정산확정금액 (B)')
      glossaryKey: { type: String, default: '' },
      // 설명 직접 지정(지정 시 사전 조회 생략)
      text: { type: String, default: '' },
    },

    computed: {
      description(): string {
        return this.text || rehabilitationTermDescription(this.glossaryKey || this.term)
      },

      // 마지막 어절 앞부분(공백 포함) — 어절 단위 줄바꿈 허용 구간
      head(): string {
        const index = this.term.lastIndexOf(' ')
        return index < 0 ? '' : this.term.slice(0, index + 1)
      },

      // 마지막 어절 — 아이콘과 함께 nowrap
      tail(): string {
        const index = this.term.lastIndexOf(' ')
        return index < 0 ? this.term : this.term.slice(index + 1)
      },
    },
  })
